<template>
	<div class="clue-drawer">
		<drawerHeader v-bind="headerInfo" :logo="logo" v-on="$listeners"></drawerHeader>
		<sky-tabs
			v-model="tabValue"
			:tabList="tabList"
			class="custclass-tab"
			:customClass="false"
		></sky-tabs>
		<div class="component">
			<el-scrollbar style="height: 100%">
				<component
					:is="tabValue"
					:id="id"
					:type="type"
					:sourceType="headerInfo.sourceType"
					v-bind="$attrs"
				></component>
				<!-- <div class="info">
				<img src="~@/assets/empty_images/zanwushuju.png" />
				<div>暂无相关信息</div>
			</div> -->
				<!-- <chatActionItems
					:id="id"
					:nickname="headerInfo.nickname"
					:messengerUserId="messengerUserId"
					v-bind="$attrs"
				></chatActionItems> -->
			</el-scrollbar>
		</div>
	</div>
</template>
<script>
import skyTabs from '@/components/iglobalwin/formComponents/tabs/sky-tabs.vue';
import drawerHeader from '@/components/chat/drawer-header.vue';
import attrInfo from '@/components/chat/components/attrInfo.vue';
import chatActionItems from '@/components/chat/fold/chat-action-items.vue';
export default {
	props: {
		id: { type: String },
		messengerUserId: null,
		headerInfo: {
			type: Object,
		},
		logo: '',
	},
	data() {
		return {
			tabValue: 'attrInfo',
			tabList: [
				{
					label: '归因',
					name: 'attrInfo',
				},
			],
			visable: false,
			assign_visible: false,
			type: 0,
		};
	},
	components: {
		drawerHeader,
		skyTabs,
		attrInfo,
		chatActionItems,
	},
};
</script>
<style lang="scss" scoped>
.sky-tabs {
	padding: 0px !important;
}
.custclass-tab {
	::v-deep  .el-tabs__header {
		margin: 0px !important;
	}
	::v-deep .el-tabs__item {
		padding-left: 20px !important;
	}
}
.clue-drawer {
	width: 380px;
	height: 100%;
	display: flex;
	flex-direction: column;
	::v-deep .el-scrollbar__wrap {
		overflow-x: hidden;
	}
	::v-deep  .el-tabs {
		.el-tabs__header {
			margin: 0;
		}

		.el-tabs__item {
			padding: 0 10px;
		}

		.el-tabs__active-bar {
			height: 3px;
		}

		.el-tabs__nav-wrap {
			background-color: #fafafa;
			padding: 0 5px;
		}

		.el-tabs__nav-wrap::after {
			height: 1px;
		}
	}
}
.component {
	/* flex: 1; */
	/* height:900px !important; */
	height: calc(100vh - 370px);
	/* overflow-y: auto; */
}
</style>
